import { render, staticRenderFns } from "./CommitedInvestments.vue?vue&type=template&id=484f568d&"
import script from "./CommitedInvestments.vue?vue&type=script&lang=js&"
export * from "./CommitedInvestments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports